import { render, staticRenderFns } from "./ResumeUpload.vue?vue&type=template&id=3afc8da5"
import script from "./ResumeUpload.vue?vue&type=script&lang=js"
export * from "./ResumeUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports